import { useEffect } from 'react';
import { EVENT_AESTHETICS } from './registry';
import AestheticEventCard from './AestheticEventCard';
import AestheticSwatch from './AestheticSwatch';

// Web port of app/components/eventAesthetics/EventAestheticPicker.jsx. A modal
// listing every aesthetic, each row a live preview of the in-progress event in
// that look. Selecting keeps the sheet open (so the user can audition); Done /
// Cancel / backdrop / Escape close it. `current` is the form value (null = none).
const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0a0a0a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export default function EventAestheticPicker({ current, draftEvent, onSelect, onClose }) {
  const currentId = current || 'none';

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="modal-overlay ae-picker-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal ae-picker-modal" role="dialog" aria-modal="true" aria-label="Event Aesthetic">
        <div className="modal-header">
          <button type="button" className="ae-picker-cancel" onClick={onClose}>Cancel</button>
          <span className="event-modal-title">Event Aesthetic</span>
          <button type="button" className="ae-picker-done" onClick={onClose}>Done</button>
        </div>
        <div className="ae-picker-body">
          <p className="ae-picker-caption">Pick a look for this event's card. The size stays the same — only the styling changes.</p>
          {EVENT_AESTHETICS.map((a) => {
            const selected = a.id === currentId;
            return (
              <button
                key={a.id}
                type="button"
                className={`ae-option${selected ? ' selected' : ''}`}
                onClick={() => onSelect(a.id === 'none' ? null : a.id)}
              >
                <div className="ae-option-head">
                  <AestheticSwatch id={a.id} />
                  <div style={{ flex: 1, textAlign: 'left' }}>
                    <div className="ae-option-name">{a.name}</div>
                    {a.subtitle ? <div className="ae-option-sub">{a.subtitle}</div> : null}
                  </div>
                  {selected ? <span className="ae-check"><CheckIcon /></span> : <span className="ae-check-empty" />}
                </div>
                <AestheticEventCard event={draftEvent} aesthetic={a} previewMode />
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
